import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./CombinedSidebar";
import TopNavBar from "./TopNavBar";

const Layout = ({ isMobileOpen, toggleMobileSidebar }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  // console.log("Layout - location.state:", location.state);
  return (
    <div className="flex flex-col md:flex-row">
      {!isLoginPage && (
        <Sidebar
          isMobileOpen={isMobileOpen}
          toggleMobileSidebar={toggleMobileSidebar}
        />
      )}

      <div className="flex-1 flex flex-col">
        {!isLoginPage && (
          <TopNavBar
            toggleMobileSidebar={toggleMobileSidebar}
            communityName={location.state?.communityName || ""}
          />
        )}

        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
